<div class="container consulta-detalhe-busca">
    <div class="content">
        <div class="menu">
            <p><strong>Buscar por:</strong></p>
            <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">

                <button type="button" id="tab-nrt-tab" class="nav-link active" data-toggle="pill" data-target="#tab-nrt" role="tab"
                    aria-controls="tab-nrt" aria-selected="true">
                    <mat-icon class="checked-icon">check_circle</mat-icon>
                    <mat-icon class="unchecked-icon">radio_button_unchecked</mat-icon>
                    NRT
                </button>

                <button type="button" id="tab-idconta-tab" class="nav-link" data-toggle="pill" data-target="#tab-idconta" role="tab"
                    aria-controls="tab-idconta" aria-selected="false">
                    <mat-icon class="checked-icon">check_circle</mat-icon>
                    <mat-icon class="unchecked-icon">radio_button_unchecked</mat-icon>
                    ID da Conta
                </button>

                <button type="button" id="tab-regClientes-tab" class="nav-link" data-toggle="pill" data-target="#tab-regClientes" role="tab"
                    aria-controls="tab-regClientes" aria-selected="false">
                    <mat-icon class="checked-icon">check_circle</mat-icon>
                    <mat-icon class="unchecked-icon">radio_button_unchecked</mat-icon>
                    Registro do Cliente
                </button>

                <button type="button" class="nav-link" id="tab-numbRastreio-tab" data-toggle="pill" data-target="#tab-numbRastreio" role="tab"
                    aria-controls="tab-numbRastreio" aria-selected="false">
                    <mat-icon class="checked-icon">check_circle</mat-icon>
                    <mat-icon class="unchecked-icon">radio_button_unchecked</mat-icon>
                    Número do Rastreio
                </button>

                <button type="button" id="tab-AgenciaeConta-tab" class="nav-link" data-toggle="pill" data-target="#tab-AgenciaeConta" role="tab"
                    aria-controls="tab-AgenciaeConta" aria-selected="false">
                    <mat-icon class="checked-icon">check_circle</mat-icon>
                    <mat-icon class="unchecked-icon">radio_button_unchecked</mat-icon>
                    Agência e conta
                </button>

                <button type="button" id ="tab-nfe-tab" class="nav-link" data-toggle="pill" data-target="#tab-nfe" role="tab"
                    aria-controls="tab-nfe" aria-selected="false">
                    <mat-icon class="checked-icon">check_circle</mat-icon>
                    <mat-icon class="unchecked-icon">radio_button_unchecked</mat-icon>
                    NF-e
                </button>
            </div>
        </div>

        <div class="forms">
            <p><strong>Formulário de busca</strong></p>
            <div class="tab-content" id="v-pills-tabContent">
                <h3>Informações para a busca</h3>
                <hr>

                <div class="tab-pane fade show active" id="tab-nrt" role="tabpanel" aria-labelledby="tab-nrt-tab">
                    <!-- ABA CONSULTA POR NRT -->
                    <app-detalhe-formulario-nrt #formNRT [clientes]="clientes"></app-detalhe-formulario-nrt>
                </div>

                <div class="tab-pane fade" id="tab-idconta" role="tabpanel" aria-labelledby="tab-idconta-tab">
                    <!-- ABA CONSULTA POR ID CONTA -->
                    <app-detalhe-formulario-idconta #formIDCONTA  [clientes]="clientes"></app-detalhe-formulario-idconta>
                </div>

                <div class="tab-pane fade" id="tab-regClientes" role="tabpanel" aria-labelledby="tab-regClientes-tab">
                    <!-- ABA CONSULTA POR REGISTRO DO CLIENTE -->
                    <app-detalhe-formulario-registrocliente #formREGISTROCLIENTE [clientes]="clientes">
                    </app-detalhe-formulario-registrocliente>
                </div>

                <div class="tab-pane fade" id="tab-numbRastreio" role="tabpanel" aria-labelledby="tab-numbRastreio-tab">
                    <!-- ABA CONSULTA POR NUMERO RASTREIO -->
                    <app-detalhe-formulario-numerorastreio #formNRASTREIO [clientes]="clientes">
                    </app-detalhe-formulario-numerorastreio>
                </div>

                <div class="tab-pane fade" id="tab-AgenciaeConta" role="tabpanel"
                    aria-labelledby="tab-AgenciaeConta-tab">
                    <!-- ABA CONSULTA POR AGENCIA E CONTA -->
                    <app-detalhe-formulario-agenciaconta #formAGCC [clientes]="clientes"></app-detalhe-formulario-agenciaconta>
                </div>

                <div class="tab-pane fade" id="tab-nfe" role="tabpanel" aria-labelledby="tab-nfe-tab">
                    <!-- ABA CONSULTA POR NFE -->
                    <app-detalhe-formulario-nfe #formNFE [clientes]="clientes"></app-detalhe-formulario-nfe>
                </div>
            </div>
        </div>
    </div>
</div>
